import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { AuthState, AuthStateModel } from '@x/ecommerce-shop/app/core/auth/state/auth.state';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'x-logged-in',
  templateUrl: './logged-in.component.html',
  styleUrls: ['./logged-in.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoggedInComponent {
  open$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Select(AuthState) state$: Observable<AuthStateModel>;

  overlayKeyDown(event: any) {
    if (event.key === 'Escape') {
      this.open$.next(false);
    }
  }
}
